<template>
  <div class="report-profile-info__wrapper">
    <div class="report-profile-info__title">
      Profile
    </div>
    <div class="report-profile-info__content-wrapper">
      <VueSkeletonLoader
        v-if="loading"
        animation="wave"
        class="mb-4"
        :color="'#bec3d8'"
        :height="40"
        :radius="'2'"
        type="rect"
      />

      <div
        v-if="showClusterBlock || showClusterLabels"
        class="report-profile-info__owner-block"
      >
        <div class="report-profile-info__sub-title">
          Entity
        </div>
        <ProfileOwner
          v-if="showClusterBlock"
          :is-pdf="isPdf"
          :owner-data="profileInfo.clusterData"
        />
        <ProfileLabels
          v-if="showClusterLabels"
          :is-pdf="isPdf"
          :owner-data="profileInfo.clusterData"
        />
      </div>

      <div
        v-if="showOwnerBlock || showOwnerLabels"
        class="report-profile-info__owner-block"
      >
        <div class="report-profile-info__sub-title">
          Account Holder
        </div>
        <ProfileOwner
          v-if="showOwnerBlock"
          :is-pdf="isPdf"
          :owner-data="profileInfo"
        />
        <ProfileLabels
          v-if="showOwnerLabels"
          :is-pdf="isPdf"
          :owner-data="profileInfo"
        />
      </div>

      <div
        v-if="
          !loading &&
            !showClusterBlock &&
            !showOwnerBlock &&
            !showClusterLabels &&
            !showOwnerLabels
        "
        class="bold"
      >
        Not identified
      </div>
    </div>
  </div>
</template>

<script>
// Components
import VueSkeletonLoader from 'skeleton-loader-vue'
import ProfileOwner from '@/pages/report/components/profile-info/ProfileOwner'
import ProfileLabels from '@/pages/report/components/profile-info/ProfileLabels'

export default {
  name: 'ProfileInfo',
  components: { VueSkeletonLoader, ProfileLabels, ProfileOwner },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    profileInfo: {
      type: Object,
      default: () => ({}),
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showClusterBlock() {
      const cluster = this.profileInfo?.clusterData || {}
      return (
        (cluster.owner || cluster.description || cluster.entityData?.name) &&
        !this.loading
      )
    },
    showOwnerBlock() {
      const ownerData = this.profileInfo || {}
      return (
        (ownerData.owner ||
          ownerData.description ||
          ownerData.entityData?.name) &&
        !this.loading
      )
    },
    showClusterLabels() {
      const clusterType =
        Object.keys(this.profileInfo?.clusterData?.type || {}).length ||
        this.profileInfo.clusterData?.meta?.length ||
        this.profileInfo.clusterData?.tags?.length

      return clusterType && !this.loading
    },
    showOwnerLabels() {
      const ownerType =
        Object.keys(this.profileInfo?.type || {}).length ||
        this.profileInfo?.meta?.length ||
        this.profileInfo?.tags?.length

      return ownerType && !this.loading
    },
  },
}
</script>
<style scoped>
.report-profile-info__title {
  font-size: var(--Size-2XL, 20px);
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 28px);
}
.report-profile-info__sub-title {
  color: var(--Content-Tertiary);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 4px;
}
.report-profile-info__wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.report-profile-info__content-wrapper {
  display: flex;
  gap: 24px;
}
.report-profile-info__owner-block {
  flex: 1;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1023px) {
  .report-profile-info__content-wrapper {
    flex-direction: column;
  }
}
</style>
